module.exports = __webpack_public_path__ + "fonts/Montserrat-LightItalic.7c9151e.woff";